// extracted by mini-css-extract-plugin
module.exports = {"button":"_3Cj72","icon":"b-Mpm","facebook":"_3fmqK","twitter":"_2XbTt","link":"_2z5H5"};